import { fetchApi } from '@/services/api-client';

export type VisitType = {
  id: string;
  label: string;
  sortOrder: number;
  active: boolean;
};

export type VisitTypeInput = { label: string; sortOrder?: number; active?: boolean };

export const medicalVisitTypesApi = {
  list: () => fetchApi<VisitType[]>('/medical/visit-types'),
  create: (data: VisitTypeInput) =>
    fetchApi<VisitType>('/medical/visit-types', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: Partial<VisitTypeInput>) =>
    fetchApi<VisitType>(`/medical/visit-types/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  remove: (id: string) => fetchApi<{ success: true }>(`/medical/visit-types/${id}`, { method: 'DELETE' }),
};
